import apiClient from "../utils/axiosConfig";
import { getApiUrl, API_ENDPOINTS } from "../Configurations/config";

/**
 * Feedback Service - Handles all feedback related API calls
 */
class FeedbackService {
  /**
   * Submit feedback for a message
   * @param {string} sessionId - Session ID
   * @param {number} messageId - Message ID
   * @param {string} feedback - Feedback type ('upvote' or 'downvote')
   * @param {string} comment - Optional comment for feedback
   * @returns {Promise} API response
   */
  async submitFeedback(sessionId, messageId, feedback, comment = "") {
    try {
      const requestBody = {
        session_id: sessionId,
        message_id: messageId,
        feedback: feedback,
      };

      if (comment) {
        requestBody.comment = comment;
      }

      const response = await apiClient.post(
        getApiUrl(API_ENDPOINTS.SESSIONS.FEEDBACK),
        requestBody
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Submit upvote feedback
   * @param {string} sessionId - Session ID
   * @param {number} messageId - Message ID
   * @returns {Promise} API response
   */
  async submitUpvote(sessionId, messageId) {
    return this.submitFeedback(
      sessionId,
      messageId,
      "upvote",
      "Helpful answer!"
    );
  }

  /**
   * Submit downvote feedback
   * @param {string} sessionId - Session ID
   * @param {number} messageId - Message ID
   * @param {string} comment - Comment explaining the downvote
   * @returns {Promise} API response
   */
  async submitDownvote(sessionId, messageId, comment = "") {
    return this.submitFeedback(sessionId, messageId, "downvote", comment);
  }
}

export const feedbackService = new FeedbackService();
export default feedbackService;

